import { Status } from "../../sharedComponents/StatusIndicator";
import {
  getCountryFromCode,
  getSubdivisionFromName,
} from "../Locations/Country";
import {
  findEstablishmentType,
  isLocationPhysical,
  LocationAttr,
  LocationFormInput,
} from "../Locations/Location";

interface LocationType {
  id: string;
  key: string;
  label: string;
  lineage: string;
  parentLocation: { id: string };
  status: string;
  isPhysicalLocation: boolean;
  selectable?: boolean;
  children?: Array<LocationType>;
}

const mapDefaultValues = (
  location: LocationAttr,
  countryList: any
): LocationFormInput => {
  const countryValue = getCountryFromCode(
    location?.address?.nation || undefined,
    countryList
  );

  const subValue = getSubdivisionFromName(
    location?.address?.subdivision || undefined,
    countryValue?.subdivisions
  );

  return {
    address: {
      address1: location?.address?.address1 ?? "",
      address2: location?.address?.address2 ?? "",
      city: location?.address?.city ?? "",
      nation: countryValue ?? "",
      postalCode: location?.address?.postalCode ?? "",
      subdivision: subValue ?? "",
    },
    id: location?.id ?? "",
    lineage: location?.lineage ?? "",
    locationStatus: (location?.locationStatus as Status) ?? null,
    name: location?.name ?? "",
    ein: location?.ein ?? "",
    establishmentType:
      findEstablishmentType(location?.establishmentType) ?? null,
    industryDescription: location?.industryDescription ?? "",
    isPhysicalLocation: location?.isPhysicalLocation ?? null,
    naicsCode: location?.naicsCode ?? "",
    shortCode: location?.shortCode ?? "",
    sicCode: location?.sicCode ?? "",
  };
};

export type { LocationType };
export { mapDefaultValues };
